import type { Participant } from '@seen/core/models/patients/participant'
import type { JSX } from 'react'
import { CurrentParticipantProvider } from '#src/components/CurrentParticipantProvider.tsx'
import { PatientDetailContent } from '#src/components/patient/detail-content/PatientDetailContent.tsx'
import { PatientHeaderCard } from '#src/components/patient/PatientHeaderCard.tsx'
import { PatientMoreMenu } from '#src/components/patient/PatientMoreMenu.tsx'

export function PatientDetail({
  participant,
  scrollRestorationIdPrefix,
}: {
  participant: Participant
  scrollRestorationIdPrefix: string | null
}): JSX.Element {
  // Header and tabs sit in a sticky blurred container that the tab content
  // scrolls behind; PatientDetailContent owns that layout.
  return (
    <CurrentParticipantProvider patientId={participant.id}>
      <PatientDetailContent
        key={participant.id}
        participant={participant}
        className="size-full min-h-0"
        scrollRestorationIdPrefix={scrollRestorationIdPrefix}
        header={
          <PatientHeaderCard
            participant={participant}
            // Flush the dots icon with the card's inner right edge.
            actions={
              <PatientMoreMenu participant={participant} className="-mr-3" />
            }
          />
        }
      />
    </CurrentParticipantProvider>
  )
}
